import { createSelector } from 'reselect';

const userSelector = createSelector([(store) => store.user], (user) => ({ user }));

export { userSelector };
